import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ProductCard from "../components/ProductCard";
import Gallery from "../components/Gallery";




import rajaniStick from "../assets/rajanigandha-stick.png";
import gandhaMala from "../assets/gandha-mala.jpg";
import jobaMala from "../assets/joba mala.jpg";
import rajaniMala from "../assets/rajani-mala.jpg";
import roseMala from "../assets/rose-mala.png";
import aparajitaMala from "../assets/Aparajita-mala.webp";
import sunflower from "../assets/sunflower.jpeg";
import zerbera from "../assets/zerbera.jpg";

const Home = () => {

  // 📩 Contact form
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  // 🌸 Flowers
  const [flowers, setFlowers] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("flowers")) || [];
    setFlowers(stored);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = `Name: ${name}%0AMessage: ${message}`;
    window.open(`https://wa.me/919732108660?text=${text}`, "_blank");

    setName("");
    setMessage("");
  };

  return (
    <>
      <Navbar />

      {/* 🏠 HERO */}
      <div id="home">
        <Hero />
      </div>

      {/* 🌸 FLOWERS */}
      <div id="flowers" className="products-section">
        <h2>Popular Flowers</h2>

        <div className="product-grid">

  
  <ProductCard name="Gerbera" image={zerbera} />
  <ProductCard name="Rajanigandha Mala" image={rajaniMala} />
  <ProductCard name="Rajani Stick" image={rajaniStick} />
  <ProductCard name="Gandha Mala" image={gandhaMala} />
  <ProductCard name="Joba Mala" image={jobaMala} />
  <ProductCard name="Rose Mala" image={roseMala} />
  <ProductCard name="Aparajita Mala" image={aparajitaMala} />
  <ProductCard name="Sunflower" image={sunflower} />
  

  {/* Admin added */}
  {flowers.map((f, index) => (
    <ProductCard key={index} name={f.name} image={f.image} />
  ))}

</div>
      </div>

      {/* 📸 GALLERY (🔥 FIXED POSITION) */}
      <div id="gallery">
        <Gallery />
      </div>

      {/* 📞 CONTACT */}
      <div id="contact" className="contact-section">
        <h2>Contact Us</h2>

        <p>📍 New Kalpana Nursery, Kabikankan Road, Gotan, West Bengal 712410</p>

        <div className="contact-buttons">
          <a href="tel:9732108660">
            <button className="btn">📞 Call Now</button>
          </a>

          <a href="https://wa.me/919732108660" target="_blank" rel="noreferrer">
            <button className="btn whatsapp">💬 WhatsApp</button>
          </a>
        </div>
      </div>

      {/* 📝 FORM */}
      <div className="form-section">
        <h2>Send Us a Message</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <textarea
            placeholder="Your Message"
            rows="4"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>

          <button type="submit" className="btn">
            Send Message
          </button>
        </form>
      </div>

      {/* 📍 MAP */}
      <div className="map-section">
        <h2>Our Location</h2>

        <iframe
          src="https://www.google.com/maps?q=New+Kalpana+Nursery+Gotan+West+Bengal&output=embed"
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: "15px" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </>
  );
};

export default Home;